/* eslint-disable max-len */
const faq = `

<div class="accordion-wrapper">

<div class="left">

<div class="accordion">
<input type="checkbox" id="chck2">
<label class="accordion-label" for="chck2">Personal data registration</label>
<div class="accordion-content">
<p>
You will be asked to enter personal data such as ID card, bank information, and NPWP. Make sure that the data you want to register has never been registered in an Easycash account before.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck3">
<label class="accordion-label" for="chck3">Easycash lending amount</label>
<div class="accordion-content">
<p>
The minimum nominal lending at Easycash is IDR1,000,000 and the maximum lending starts from IDR30 million for exclusive new user products (30 or 60 day period) and IDR10 billion for lending products with a period of 30 – 360 days.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck4">
<label class="accordion-label" for="chck4">Easycash lending interest rate</label>
<div class="accordion-content">
<p>
The lending interest rate adjusts to the selected lending product and the details can be checked directly on the app. The interest rate varies and can change at any time.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck5">
<label class="accordion-label" for="chck5">Withholding tax slip</label>
<div class="accordion-content">
<p>
The proof of withholding tax for all transactions regarding payment of interest on lending received will be made in one tax period, which will be given 1 month after the lending period ends.
<br>
You can submit a request for proof of tax withholding by sending an email to <a href="mailto: cs.lender@easycash.id ">cs.lender@easycash.id </a> and providing the subject "Request for Proof of Tax Withholding" attached with the following details:
<ol>
<li>Registered cellphone number</li>
<li>Active email used</li>
<li>Do you use a combined NPWP: Yes/No</li>
</ol>
After that, wait for a reply from our email team.
</p>
<p></p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck6">
<label class="accordion-label" for="chck6">Withholding tax detail</label>
<div class="accordion-content">
<p>
Based on the applicable laws and regulations, the platform will withhold tax on all your lending in Easycash that matures after 1 May 2022.
<br>
For the withholding tax rate is 15% for users who have completed the NPWP data, and 30% for users who haven't completed or have completed the NPWP data incorrectly.
</p>
</div>
</div>

</div>

<div class="right">

<div class="accordion">
<input type="checkbox" id="chck7">
<label class="accordion-label" for="chck7">Privy ID signature or digital signature</label>
<div class="accordion-content">
<p>
After the fund top up process is carried out, you have to do digital signature before continuing the lending process. When you sign Privy ID, make sure the email address and Privy ID username are correct.
<br>
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck8">
<label class="accordion-label" for="chck8">Disbursement of funds</label>
<div class="accordion-content">
<p>
When your lending has matured, the funds that have been invested along with the lending interest will be transferred to the balance account. The withdrawal process can be done manually by taking D+3 (three) working days excluding holidays. You can withdraw funds with the following notes:
<ol>
<li>Daily withdrawal transaction limit : 1 billion rupiah/Day</li>
</ol>

<p>However, if you want to withdraw 1 billion rupiah, then please make a withdrawal of 200 millions rupiah 5 times in 1 day and the withdrawal amount depends on the bank's limit that you use. If you are using a bank other than BCA, we recommend you to not withdraw no more than 100 millions rupiah per day to avoid failed withdrawals.</p>
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck9">
<label class="accordion-label" for="chck9">Is it safe to become a lender at Easycash?</label>
<div class="accordion-content">
<p>
Of course, it's safe. As a platform that has been registered and supervised by OJK, Easycash conducts an analysis process for prospective borrowers recipients using a self-evolving machine learning that runs more than 6,000 features and 10 types of scenario analysis that can reflect the overall credit condition of the borrower. Easycash provides transparent information that can be accessed through the features available on the app.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck10">
<label class="accordion-label" for="chck10">Insurance</label>
<div class="accordion-content">
<p>
Your funds are currently protected with Intra Asia and Reliance Insurance.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck11">
<label class="accordion-label" for="chck11">Top up fund</label>
<div class="accordion-content">
<p>
To top up funds, you can do it through the Bank BCA Virtual Account. If you want to top up via other banks, you still have to use BCA Virtual Account with an estimated entry into your balance account in 1X24 hours.
</p>
</div>
</div>

</div>

</div>
`;

export default faq;
